import { useState } from 'react';
import { apiFetch } from '../../../context/AuthContext';

function useEmployees(userRole) {
    const apiBaseUrl = process.env.REACT_APP_BASE_URL;

    const [availableEmployees, setAvailableEmployees] = useState([]);

    const fetchAvailableEmployees = async () => {
        try {
            const headers = {};
            if (userRole === "manager") {
                headers['x-view-type'] = 'manager';
            }

            // fields=basic: AssignModal renders only infinityCode, clientCode
            // and sr. The default response carries all ~87 employee columns —
            // ~4.3 MB of JSON for a 1,600-employee manager vs ~330 kB here.
            // Widen this only if the modal starts showing more columns.
            const res = await apiFetch(`${apiBaseUrl}/employees/visibility?fields=basic`, {
                method: "GET",
                headers
            });
            const data = await res.json();
            setAvailableEmployees(data.employees || []);
        } catch (err) {
            console.error('Error fetching employees:', err);
        }
    };

    return { availableEmployees, fetchAvailableEmployees };
}

export default useEmployees;